import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import BusinessSetup from './pages/BusinessSetup';
import StaffManagement from './pages/StaffManagement';
import ServicesManagement from './pages/ServicesManagement';
import WaitlistManagement from './pages/WaitlistManagement';
import CancellationMonitor from './pages/CancellationMonitor';
import NotificationCenter from './pages/NotificationCenter';
import PredictiveAnalytics from './pages/PredictiveAnalytics';
import Settings from './pages/Settings';
import AuthCallback from './pages/AuthCallback';
import './App.css';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('slotrescue_token');
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/business-setup"
            element={
              <PrivateRoute>
                <BusinessSetup />
              </PrivateRoute>
            }
          />
          <Route
            path="/staff"
            element={
              <PrivateRoute>
                <StaffManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/services"
            element={
              <PrivateRoute>
                <ServicesManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/waitlist"
            element={
              <PrivateRoute>
                <WaitlistManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/predictions"
            element={
              <PrivateRoute>
                <PredictiveAnalytics />
              </PrivateRoute>
            }
          />
          <Route
            path="/cancellations"
            element={
              <PrivateRoute>
                <CancellationMonitor />
              </PrivateRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <PrivateRoute>
                <NotificationCenter />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
